var _module = require('../components/module');
var he = require('he');

/*
escapeHtmlEntities
*/
_module.filter('escapeHtmlEntities', [
    function () {
        return function escapeHtmlEntities(str) {
            return he.decode(str).replace(/\<\/{0,1}\w+\/{0,1}>/gi, '');
        };
    }
]);
